export const TimingLabel = {
  PROJECTED_END_DATE: "Projected End Date",
  EARLIEST_START_DATE: "Earliest Start Date",
  REQUESTED_BY_DATE: "Requested By Date",
  ESTIMATED_SITE_READY_DATE: "Est. Site Ready Date",
  AHEAD_OF_SCHEDULE: "Ahead of Schedule",
  BEHIND_SCHEDULE: "Behind Schedule",
  NEXT_SCHEDULED_CONTACT: "Next Scheduled Contact",
  MAIN_CONTACT: "Main Contact",
  SCHEDULED_END_DATE: "Scheduled End Date",
} as const;

export const ContactsLabel = {
  COORDINATOR: "Coordinator",
  MAIN_CONTACT: "Main Contact",
} as const;

export type TimingLabel = typeof TimingLabel[keyof typeof TimingLabel];
export type ContactsLabel = typeof ContactsLabel[keyof typeof ContactsLabel];
